import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

export type ProfileService = 'spotify' | 'youtube' | 'facebook' | 'press' | 'bio';

const SERVICE: Readonly<Record<ProfileService, { className: string | undefined; mark: string }>> = {
  spotify: { className: styles.svcSpotify, mark: 'S' },
  youtube: { className: styles.svcYoutube, mark: 'Y' },
  facebook: { className: styles.svcFacebook, mark: 'f' },
  press: { className: styles.svcPress, mark: 'P' },
  bio: { className: styles.svcBio, mark: 'B' },
};

interface ProfileCardProps {
  service: ProfileService;
  name: string;
  size: string;
  chip: React.ReactNode;
  wide?: boolean;
  testId: string;
  children: React.ReactNode;
}

/** One card of the Profile page (design a1 `.ap-card`): the service mark, the name, the size line and the chip. */
const ProfileCardComponent: React.FC<ProfileCardProps> = ({
  service,
  name,
  size,
  chip,
  wide = false,
  testId,
  children,
}) => (
  <section className={clsx(styles.card, wide && styles.cardWide)} data-testid={testId}>
    <div className={styles.cardHead}>
      <span className={clsx(styles.svc, SERVICE[service].className)} aria-hidden="true">
        {SERVICE[service].mark}
      </span>
      <div className={styles.grow}>
        <b>{name}</b>
        <small>{size}</small>
      </div>
      {chip}
    </div>
    {children}
  </section>
);

export const ProfileCard = TypedMemo(ProfileCardComponent);
